import PropTypes from "prop-types";

/* Radio tiles — used for the reason list and the resolution list. */
const ChoiceGrid = ({ name, options, value, onChange, columns }) => (
  <div
    className={`c4rtn__choices c4rtn__choices--${columns}`}
    role="radiogroup"
    aria-label={name}
  >
    {options.map((option) => {
      const id = `${name}-${option.value.replace(/\W+/g, "-").toLowerCase()}`;

      return (
        <label
          className={`c4rtn__choice${
            value === option.value ? " c4rtn__choice--selected" : ""
          }`}
          key={option.value}
          htmlFor={id}
        >
          <input
            className="c4rtn__radio"
            id={id}
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          <span className="c4rtn__radio-mark" aria-hidden="true" />
          <span className="c4rtn__choice-body">
            <span className="c4rtn__choice-label">{option.value}</span>
            <span className="c4rtn__choice-hint">{option.hint}</span>
          </span>
        </label>
      );
    })}
  </div>
);

ChoiceGrid.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  columns: PropTypes.oneOf([2, 3]),
};

ChoiceGrid.defaultProps = { columns: 2 };

export default ChoiceGrid;
